import module from 'recursoshumanos/module.js'
import template from './template.html'
import { uniq } from 'lodash'
import * as moment from 'moment'

const fechaLoteRegex = /^\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2]\d|3[0-1]) (?:0[0-9]|1[0-9]|2[0-4]):(?:[0-5][0-9])$/
const crearRegistro = (item) => ({
  id_proyecto: item.seleccionado.id_proyecto,
  id_colaborador: item.seleccionado.id_colaborador,
  id_movimiento: item.seleccionado.id_movimiento,
  coincide_nombre: item.seleccionado.validaciones.nombre.valido,
  coincide_nss: item.seleccionado.validaciones.nss.valido,
  coincide_salario: item.seleccionado.validaciones.salario.valido,
  coincide_estatus: item.seleccionado.validaciones.estatus.valido,
  nombre: item.registro.nombre,
  nss: item.registro.nss,
  tipo_movimiento: item.registro.tipo_movimiento,
  salario_base: item.registro.salario_base,
  extemporaneo: item.registro.extemporaneo,
  jornada_reducida: item.registro.jornada_reducida,
  umf: item.registro.umf,
  tipo_salario: item.registro.tipo_salario,
  fecha_movimiento: item.registro.fecha_movimiento,
  tipo_trabajador: item.registro.tipo_trabajador,
  causa_baja: item.registro.causa_baja,
})

export class RecursoshumanosLotesCargarConfirmarComponent {
  data
  onClose
  respuesta = null
  numero_lote = ''
  fecha_lote = ''
  validacionesFechaLote = {
    formato: (value) => {
      return !value || value.length !== 16 || fechaLoteRegex.test(value)
    },
    valida: (value) => {
      if (!value || value.length !== 16) return true
      const fecha = new Date(value)
      return (!!(+fecha) && fecha.getDate() === +value.substr(8, 2))
    },
  }
  validacionesNumeroLote = {
    existe: (value) => {
      return value
        ? this.RecursosHumanosLotesIMSSExiste.get(value)
          .then(({data}) => data.existe ? this.$q.reject() : this.$q.resolve())
        : this.$q.resolve()
    },
  }

  constructor ($q, RecursosHumanosLotesIMSS, RecursosHumanosLotesIMSSExiste) {
    this.$q = $q
    this.RecursosHumanosLotesIMSS = RecursosHumanosLotesIMSS
    this.RecursosHumanosLotesIMSSExiste = RecursosHumanosLotesIMSSExiste
  }

  guardar () {
    if (this.actualizando) return

    this.actualizando = true

    const registros = this.data.registros.map((item) => crearRegistro(item))
    const data = {...this.data, numero_lote:this.numero_lote, fecha_lote:this.fecha_lote, registros}
    const proyectos = uniq(registros.map((item) => item.id_proyecto))
    const respuesta = {
      id_empresa: this.data.id_empresa,
      clase: this.data.clase,
      registroPatronalId: this.data.registroPatronalId,
      proyectos: proyectos,
      fecha: moment(registros[0].fecha_movimiento).startOf('month').toDate(),
    }

    this.RecursosHumanosLotesIMSS.post(data)
      .then(({data}) => (this.respuesta = {...respuesta, ...data}))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.actualizando = false))
  }

  cerrar () {
    this.onClose({$event: {detail: this.respuesta}})
  }
}

module.component('recursoshumanosLotesCargarConfirmar', {
  controller: RecursoshumanosLotesCargarConfirmarComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/cargarmovimientos/confirmar/component.js